import React from 'react';
import moment from 'moment';
import { FormatNumber2 } from '../utility/component/tools';
import '../utility/styles/print.css';

const getCompanyDetails = () => {
  try {
    return JSON.parse(localStorage.getItem('companyDetails')) || {};
  } catch (error) {
    return {};
  }
};

const PrintBillSummary = React.forwardRef((props, ref) => {
  const { data, firstDate, SecondDate, bookingCustomerDetails } = props;
  const company = getCompanyDetails();
  const companyName =
    company.companyName ||
    company.company_name ||
    localStorage.getItem('company') ||
    'Company';
  const companyAddress = [
    company.address,
    company.city,
    company.state,
    company.pinCode || company.pin_code || company.pincode,
  ]
    .filter(Boolean)
    .join(', ');
  const companyContact = [
    company.mobile && `Phone: ${company.mobile}`,
    company.email && `Email: ${company.email}`,
  ]
    .filter(Boolean)
    .join('  •  ');

  const grossTotal = data.reduce(
    (total, row) => total + (Number(row.TOTAL) || 0),
    0
  );
  const advanceTotal = data.reduce(
    (total, row) => total + (Number(row.ADVANCE_AMT) || 0),
    0
  );
  const discountTotal = data.reduce(
    (total, row) => total + (Number(row.DISCOUNT_AMOUNT) || 0),
    0
  );
  const netTotal = data.reduce(
    (total, row) => total + (Number(row.GTOTAL) || 0),
    0
  );
  const customerFilter = [
    bookingCustomerDetails?.customer_name,
    bookingCustomerDetails?.mobile,
  ]
    .filter(Boolean)
    .join(' • ');

  return (
    <div ref={ref} id="bill-summary-print" className="bill-summary-print">
      <table className="bill-summary-print-table">
        <colgroup>
          {[4, 5, 7, 11, 9, 8, 13, 9, 8, 8, 7, 11].map(
            (columnWidth, index) => (
              <col key={index} style={{ width: `${columnWidth}%` }} />
            )
          )}
        </colgroup>
        <thead>
          <tr>
            <th colSpan="12" className="print-company-header">
              <div className="print-company-name">{companyName}</div>
              {companyAddress && (
                <div className="print-company-detail">{companyAddress}</div>
              )}
              {companyContact && (
                <div className="print-company-detail">{companyContact}</div>
              )}
              <div className="print-report-heading">
                <span>Bill Summary</span>
                <span>
                  {moment(firstDate).format('DD MMM YYYY')} –{' '}
                  {moment(SecondDate).format('DD MMM YYYY')}
                </span>
              </div>
              <div className="print-report-meta">
                <span>{customerFilter || 'All customers'}</span>
                <span>{data.length} bill(s)</span>
              </div>
            </th>
          </tr>
          <tr className="print-column-header">
            <th>Invoice</th>
            <th>Booking ID</th>
            <th>Date</th>
            <th>Customer</th>
            <th>Family Member</th>
            <th>Mobile</th>
            <th>Address</th>
            <th>Company</th>
            <th>Total</th>
            <th>Advance</th>
            <th>Discount</th>
            <th>Net Amount</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            const address = [row.ADDRESS, row.CITY, row.STATE]
              .filter(Boolean)
              .join(', ');
            return (
              <tr key={`${row.INVNO}-${index}`}>
                <td className="print-center">{row.INVNO || '—'}</td>
                <td className="print-center">
                  {row.BOOKING_ORDER_NO || '—'}
                </td>
                <td className="print-center">
                  {row.DATE ? moment(row.DATE).format('DD-MM-YYYY') : '—'}
                </td>
                <td>{row.CUSTOMER_NAME || '—'}</td>
                <td>{row.FAMILY_MEM_NAME || '—'}</td>
                <td className="print-center">{row.MOBILE || '—'}</td>
                <td>{address || '—'}</td>
                <td>{row.COMPANY_NAME || '—'}</td>
                <td className="print-amount">
                  ₹{FormatNumber2(Number(row.TOTAL) || 0)}
                </td>
                <td className="print-amount">
                  ₹{FormatNumber2(Number(row.ADVANCE_AMT) || 0)}
                </td>
                <td className="print-amount">
                  ₹{FormatNumber2(Number(row.DISCOUNT_AMOUNT) || 0)}
                </td>
                <td className="print-amount print-net">
                  ₹{FormatNumber2(Number(row.GTOTAL) || 0)}
                </td>
              </tr>
            );
          })}
          <tr className="print-total-row">
            <td colSpan="8" className="print-total-label">
              Column Totals
            </td>
            <td className="print-amount">₹{FormatNumber2(grossTotal)}</td>
            <td className="print-amount">₹{FormatNumber2(advanceTotal)}</td>
            <td className="print-amount">₹{FormatNumber2(discountTotal)}</td>
            <td className="print-amount print-net">
              ₹{FormatNumber2(netTotal)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

export default PrintBillSummary;
